export default __webpack_public_path__ + "static/tools-0eaba4ee06d909bfb26444a608f8e255.png";